import { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { PuiAlertProvider, PuiLocalizationProvider, PuiReferentielProvider } from "@portnet/ui";
import { RouterProvider } from "react-router-dom";
import { useSelector } from "react-redux";
import "./App.css";
import appearance from "./common/utils/appearance";
import router from "./common/router/router";
import config from "./config";
import useDocumentTitle from "./common/hooks/useDocumentTitle";

const App = () => {
  const token = useSelector((state) => state.auth.login.token);

  const [theme] = useState(appearance.defaultTheme);
  const [receivedTheme, setReceivedTheme] = useState(null);
  const [themeReady, setThemeReady] = useState(false);

  useDocumentTitle("Nouvelle Tarification");

  useEffect(() => {
    // Cas 1 : le thème est déjà arrivé avant le montage de React.
    const storedTheme = window.sessionStorage.getItem("theme");
    if (storedTheme) {
      try {
        setReceivedTheme(JSON.parse(storedTheme));
      } catch (e) {
        console.error("Error parsing stored theme:", e);
      }
    }

    // Cas 2 : le thème arrive après le montage.
    const handleThemeReceived = async (event) => {
      setReceivedTheme(event.detail);
      await Promise.resolve();
      setThemeReady(true);
    };

    window.addEventListener("themeReceived", handleThemeReceived);
    setThemeReady(true);

    return () => {
      window.removeEventListener("themeReceived", handleThemeReceived);
    };
  }, []);

  const finalTheme = receivedTheme ? createTheme(receivedTheme) : theme;

  // Évite un flash de couleurs par défaut avant l'arrivée du thème.
  if (!themeReady) return null;

  // Jeton : login applicatif (Redux) ou jeton transmis par le portail (sessionStorage).
  const referentielToken = token || window.sessionStorage.getItem("token");

  return (
    <ThemeProvider theme={finalTheme}>
      <CssBaseline />
      <PuiAlertProvider>
        <PuiReferentielProvider
          token={`Bearer ${referentielToken}`}
          secret
          baseURL={config.referentielBaseURL}
        >
          <PuiLocalizationProvider>
            <RouterProvider router={router} />
          </PuiLocalizationProvider>
        </PuiReferentielProvider>
      </PuiAlertProvider>
    </ThemeProvider>
  );
};

export default App;
